import React from 'react';

/**
 * @description 路由懒加载
 * @param {Element} Component 需要访问的组件
 * @param {props} props 需要访问的组件的属性
 * @returns element
 */
const lazyLoad = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: React.LazyExoticComponent<any>,
  props?: any
): React.ReactNode => {
  return <Component {...props} />;
};

export default lazyLoad;
